export default {
  getWhitelists: state => state.whitelists,
  getWhitelist: state => state.whitelist,
  getPagination: state => state.pagination,
  getPageLength: state => state.filters.params.take,
  getCurrentPage: state => state.filters.params.page,
}
